__webpack_require__.p = "/mi-assets/mi-static/mi-legal-renderer/web-rel-26.5.2-0ecaaa4-10146/_next/";